module.exports = __webpack_public_path__ + "media/images/login-bg-17b0af1ba9dbc428a67cd3040cf8de2c.webp";